import React from 'react';
import styled, { css } from 'styled-components';
import { getIn } from 'seamless-immutable';

const FastDeliveryTag = ({ stamps, oneDayDeliveryMessage }) => {
  const isFastDelivery = getIn(stamps, ['isFastDelivery'], false);
  return (
    !!isFastDelivery && (
      <DeliveryBadge>
        <DeliveryBadgeText>{oneDayDeliveryMessage}</DeliveryBadgeText>
      </DeliveryBadge>
    )
  );
};

const DeliveryBadge = styled.div`
  ${({ theme }) => css`
    color: ${theme.card.green};
    font-size: ${theme.fontSize.xxs};
    display: flex;
    gap: 3px;
    align-items: center;
  `}
`;

const DeliveryBadgeText = styled.span`
  ${({ theme }) => css`
    color: ${theme.card.green};
    font-size: ${theme.fontSize.xxs};
  `}
`;

export default FastDeliveryTag;
